import { useIntl } from "react-intl";

export const useTranslationHomePage = () => {
  const intl = useIntl();

  // FAQ
  const hosIsThisDifferentFromOtherChatbotTitleTranslation = intl.formatMessage(
    {
      defaultMessage: "How is this different from other chatbots ?",
      id: "home.section.faq.howIsThisDifferentFromOtherChatbots.title",
    },
  );
  const hosIsThisDifferentFromOtherChatbotAnswerTranslation =
    intl.formatMessage({
      defaultMessage:
        "ChatSystem knows how you sell and follows your commercial playbook. It is not just a generic chatbot plugged on an API. It is really bringing your expertise into the customer journey.",
      id: "home.section.faq.howIsThisDifferentFromOtherChatbots.answer",
    });

  const isItGDPRCompatibleTitleTranslation = intl.formatMessage({
    defaultMessage: "Is it GDPR compliant ?",
    id: "home.section.faq.isItGDPRCompatible.title",
  });
  const isItGDPRCompatibleAnswerTranslation = intl.formatMessage({
    defaultMessage: "Yes, we are fully GDPR compliant.",
    id: "home.section.faq.isItGDPRCompatible.answer",
  });

  const doesItSpeakSeveralLanguagesTitleTranslation = intl.formatMessage({
    defaultMessage: "Does it speak several languages?",
    id: "home.section.faq.doesItSpeakSeveralLanguages.title",
  });
  const doesItSpeakSeveralLanguagesAnswerTranslation = intl.formatMessage({
    defaultMessage:
      "The chatbot speaks many languages, including English, Spanish, French, and many others.",
    id: "home.section.faq.doesItSpeakSeveralLanguages.answer",
  });

  const doesItWorkOnAnyProductsTitleTranslation = intl.formatMessage({
    defaultMessage: "Does it work on any product ?",
    id: "home.section.faq.doesItWorkOnAnyProducts.title",
  });
  const doesItWorkOnAnyProductsAnswerTranslation = intl.formatMessage({
    defaultMessage:
      "Yes, it does work on any product. It's a matter of setup between your company and ours, particularly your expertise.",
    id: "home.section.faq.doesItWorkOnAnyProducts.answer",
  });

  const canItDoSomethingElseTitleTranslation = intl.formatMessage({
    defaultMessage: "Can it do other things ?",
    id: "home.section.faq.canItDoSomethingElse.title",
  });
  const canItDoSomethingElseAnswerTranslation = intl.formatMessage({
    defaultMessage:
      "We can add custom functionalities to the chatbot depending on your needs. Agent and AI can do many things - please contact us.",
    id: "home.section.faq.canItDoSomethingElse.answer",
  });

  const isItEasyToImplementTitleTranslation = intl.formatMessage({
    defaultMessage: "Is it easy to implement?",
    id: "home.section.faq.isItEasyToImplement.title",
  });
  const isItEasyToImplementAnswerTranslation = intl.formatMessage({
    defaultMessage:
      "Yes. For a complete implementation, count about two weeks.",
    id: "home.section.faq.isItEasyToImplement.answer",
  });

  const canItBeCustomedTitleTranslation = intl.formatMessage({
    defaultMessage: "Can the look and feel be customized?",
    id: "home.section.faq.canItBeCustomed.title",
  });
  const canItBeCustomedAnswerTranslation = intl.formatMessage({
    defaultMessage:
      "Yes—completely. You can tailor the design to match your brand, including your visuals and styling.",
    id: "home.section.faq.canItBeCustomed.answer",
  });

  const faqSectionTitleTranslation = intl.formatMessage({
    defaultMessage: "Your most common questions",
    id: "home.section.faq.title",
  });

  // HEADER SLOGAN
  const headerSlogan = intl.formatMessage({
    defaultMessage:
      "The e-commerce AI agent that transforms your customer experience",
    id: "home.sloganHeader.slogan",
  });

  const headerSlogan2 = intl.formatMessage({
    defaultMessage: "Don't let your undecided customers leave again.",
    id: "home.sloganHeader.slogan.otherTry",
  });

  const headerSubSlogan = intl.formatMessage({
    defaultMessage:
      "Discover a specialized agent that understands your business inside and out",
    id: "home.sloganHeader.slogan.sub",
  });
  const headerSubSlogan2 = intl.formatMessage({
    defaultMessage:
      "Guide your visitors to the right product with an AI assistant that knows your catalogue perfectly.",
    id: "home.sloganHeader.slogan.sub.otherTry",
  });

  const headerSloganCTA = intl.formatMessage({
    defaultMessage: "See the demo",
    id: "home.sloganHeader.slogan.cta",
  });
  const headerSloganCTATryTool = intl.formatMessage({
    defaultMessage: "Try Tool",
    id: "home.sloganHeader.slogan.tryTool",
  });
  const headerSloganCTAContactUs = intl.formatMessage({
    defaultMessage: "Contact Us",
    id: "home.sloganHeader.slogan.contactUs",
  });
  const headerSloganBadgeTitle = intl.formatMessage({
    defaultMessage: "E-commerce",
    id: "home.sloganHeader.badge.title",
  });
  const headerSloganBadgeText = intl.formatMessage({
    defaultMessage: "Ideal for e-commerce teams",
    id: "home.sloganHeader.badge.text",
  });

  // video show case

  const videoShowCaseTitle = intl.formatMessage({
    defaultMessage: "A quick, concrete demo—no fluff",
    id: "home.section.video.showcase.title",
  });

  const videoShowCaseTitleSubTitle = intl.formatMessage({
    defaultMessage:
      "Watch the agent in action: precise answers, a consistent tone, and a smoother customer journey.",
    id: "home.section.video.showcase.title.subtitle",
  });

  const videoShowCaseKeyHighlight = intl.formatMessage({
    defaultMessage: "Key highlight",
    id: "home.section.video.showcase.tip.title",
  });

  const videoShowCaseTipText = intl.formatMessage({
    defaultMessage:
      "The chatbot adapts to the customer’s tone and follows your company’s sales approach.",
    id: "home.section.video.showcase.tip.text",
  });

  return {
    hosIsThisDifferentFromOtherChatbotTitleTranslation,
    hosIsThisDifferentFromOtherChatbotAnswerTranslation,
    isItGDPRCompatibleTitleTranslation,
    isItGDPRCompatibleAnswerTranslation,
    doesItSpeakSeveralLanguagesTitleTranslation,
    doesItSpeakSeveralLanguagesAnswerTranslation,
    doesItWorkOnAnyProductsTitleTranslation,
    doesItWorkOnAnyProductsAnswerTranslation,
    canItDoSomethingElseTitleTranslation,
    canItDoSomethingElseAnswerTranslation,
    isItEasyToImplementTitleTranslation,
    isItEasyToImplementAnswerTranslation,
    faqSectionTitleTranslation,
    canItBeCustomedTitleTranslation,
    canItBeCustomedAnswerTranslation,
    headerSlogan,
    headerSlogan2,
    headerSubSlogan,
    headerSubSlogan2,
    headerSloganCTA,
    headerSloganCTATryTool,
    headerSloganCTAContactUs,
    headerSloganBadgeTitle,
    headerSloganBadgeText,
    videoShowCaseTitle,
    videoShowCaseTitleSubTitle,
    videoShowCaseKeyHighlight,
    videoShowCaseTipText,
  };
};
